import * as services from './articles/services.gen';

export const useArticlesApi = () => services
